import { WorkflowsViewFilterArea } from "#src/batteries-included-components/FilterAreas/WorkflowsFilterAreas";
import {
  WorkflowsTablePanel,
  WorkflowsTablePanelProps,
} from "#src/batteries-included-components/Panels/TablePanels/WorkflowsTablePanel";
import {
  Assets,
  type AssetTypeSelectionType,
} from "@validereinc/domain-controllers";
import React from "react";

const { AssetTypeSelection } = Assets.view;

type WorkflowsAllLayoutProps = {
  tablePanelProps: WorkflowsTablePanelProps;
};

export const WorkflowsListLayout = ({
  tablePanelProps,
  defaultAssetType,
}: WorkflowsAllLayoutProps & { defaultAssetType?: AssetTypeSelectionType }) => {
  const resolvedDefaultAssetType =
    defaultAssetType ?? AssetTypeSelection.ALL_ASSETS;

  return (
    <>
      <WorkflowsViewFilterArea
        viewConfigStorageKey={tablePanelProps.viewConfigStorageKey}
        defaultAssetType={resolvedDefaultAssetType}
        showCategoryFilter={!tablePanelProps.isWithinWorkflowTemplateDetails}
        showTemplateFilter={!tablePanelProps.isWithinWorkflowTemplateDetails}
      />
      <WorkflowsTablePanel
        {...tablePanelProps}
        defaultAssetType={resolvedDefaultAssetType}
      />
    </>
  );
};
